/**
 * hooks.js
 * Cung cấp hàm exposeTestHooks() gán các API và state getters vào window object.
 * Hợp đồng kiểm thử tự động với Playwright E2E & Visual tests.
 */

import * as THREE from 'three';
import { setWalkerTime } from './modes/walker-controller.js';

export function exposeTestHooks(state, methods = {}) {
  // Gán trực tiếp Three.js instances
  window.THREE = THREE;
  if (state.camera) window.camera = state.camera;
  if (state.controls) window.controls = state.controls;

  // Sử dụng getter để đảm bảo window.* luôn đồng bộ với state nội bộ
  const defineProp = (name, getter) => {
    Object.defineProperty(window, name, {
      configurable: true,
      enumerable: true,
      get: getter
    });
  };

  defineProp('mainAvatar', () => state.mainAvatar);
  defineProp('currentAnimal', () => state.currentAnimal);
  defineProp('currentProject', () => state.currentProject);
  defineProp('dramaDirector', () => state.dramaDirector);
  defineProp('storyboardDirector', () => state.storyboardDirector);
  defineProp('characterManager', () => state.characterManager);
  defineProp('emotionEffectsManager', () => state.emotionEffectsManager);
  defineProp('projectManager', () => state.projectManager);
  defineProp('movingVehicles', () => state.movingVehicles);
  defineProp('cityGroup', () => state.cityGroup);
  defineProp('activeAvatars', () => state.activeAvatars);
  defineProp('scene', () => state.scene);
  defineProp('projectPets', () => state.projectPets);
  defineProp('renderer', () => state.renderer);

  // Gán các phương thức điều khiển toàn cục nếu được cung cấp

  if (methods.setupStudioAvatar) window.setupStudioAvatar = methods.setupStudioAvatar;
  if (methods.clearAvatars) window.clearAvatars = methods.clearAvatars;
  if (methods.loadAndApplyProject) window.loadAndApplyProject = methods.loadAndApplyProject;
  if (methods.showToastNotification) window.showToastNotification = methods.showToastNotification;

  // Hook kiểm thử: Cố định thời gian và tư thế của các avatar đang hoạt động (phục vụ deterministic visual snapshots)
  window.pauseAvatarsAt = (time = 0) => {
    window.__PAUSE_ANIMATION__ = true;
    if (state.activeAvatars) {
      state.activeAvatars.forEach((av) => {
        if (av.animator) {
          av.animator.time = time;
          av.animator.actionElapsed = time;
          av.animator.transitionProgress = 1.0;
          if (av.animator.targetAction) {
            av.animator.currentAction = av.animator.targetAction;
          }
        }
        if (av.walkerController) {
          setWalkerTime(av, time);
        }
        if (typeof av.update === 'function') {
          av.update(0);
        }
        if (typeof av.hideSpeech === 'function') {
          av.hideSpeech();
        }
      });
    }
  };
}
